module.exports = function() {
  return new Worker("/" + "stylus-transpiler.428164ba.worker.js");
};